module.exports = __webpack_public_path__ + "img/20200515-2.550e5123.jpg";